import { organizationType } from './organizationType';
import { imageObjectType } from './imageObjectType';
import { conf } from '../../configService';
import { removeEmptyProperties } from '../../../utils/objectUtils';

// @see https://schema.org/TVSeries
export const tvSeriesType = content =>
  removeEmptyProperties({
    '@type': 'TVSeries',
    '@id': `https://${conf.canonicalDomain}${content.url?.path}`,
    name: content.title,
    url: `https://${conf.canonicalDomain}${content.url?.path}`,
    publisher: organizationType(),
    keywords: content.metaTags?.keywords,
    image: imageObjectType(content.image?.entity)
  });
